import { Box, Circle, HStack, Text } from "@chakra-ui/react";
import { IMaterialIconProps, MaterialIcon } from "./MaterialIcon";

interface IconTextSmudgeProps {
  iconColor: IMaterialIconProps["color"];
  iconName: IMaterialIconProps["name"];
  text: string;
}

export const IconTextSmudge = (props: IconTextSmudgeProps) => {
  const { iconName, iconColor, text } = props;

  return (
    <HStack
      spacing="3"
      borderColor="border"
      borderWidth="1px"
      py={2}
      px={4}
      rounded="md"
    >
      <Circle borderWidth="1px" borderColor="border" bg="bg.high" p={1}>
        <MaterialIcon
          color={iconColor}
          name={iconName}
          fontSize="md"
          variant="outline"
        />
      </Circle>

      <Box>
        <Text fontWeight="medium" fontSize="sm">
          {text}
        </Text>
      </Box>
    </HStack>
  );
};
